
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshan() {



  const cardData =
  {
    keyword: 'Ashtavinayak Darshan Cab Service',
    heading: 'AB Ghule Cabs: Ashtavinayak Darshan Cab Service',
    headingDescription: 'AB Ghule Cabs offers comfortable and reliable cab services for your Ashtavinayak Darshan journey. Whether you are seeking spiritual peace or simply want to explore the holy temples, our experienced drivers and well-maintained vehicles ensure a safe, hassle-free, and memorable trip to all eight temples of Ashtavinayak. We provide affordable and flexible packages tailored to your needs.',

    top: 'Top Places to Visit in Ashtavinayak with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Moreshwar Temple (Morgaon)",
          description: "Dedicated to Lord Ganesha, this temple is considered the first of the Ashtavinayak temples. Situated in the Morgaon village, it holds great religious importance. The temple is renowned for its beautiful architecture and is a popular pilgrimage site for devotees of Lord Ganesha."
        },
        {
          title: "Siddhivinayak Temple (Siddhatek)",
          description: "Situated on the banks of the river Bhima, this temple is known for its unique idol of Lord Ganesha, facing towards the south. It is an important pilgrimage destination for devotees, who believe that the temple has the power to fulfill their wishes. The serene surroundings add to the spiritual atmosphere of the place."
        },
        {
          title: "Ballaleshwar Temple (Pali)",
          description: "This temple is famous for its large idol of Lord Ganesha and is located in Pali, a beautiful village near the Mumbai-Goa highway. The temple is an essential stop for devotees on their journey to visit the Ashtavinayak temples, offering a peaceful environment for worship and reflection."
        },
        {
          title: "Ranjangaon Temple (Ranjangaon)",
          description: "Dedicated to Lord Ganesha, this temple is located in Ranjangaon and is renowned for its historical significance and unique idol. The temple’s architecture and the legend behind the idol make it a place of immense spiritual importance for worshippers and tourists alike."
        },
        {
          title: "Vighneshwar Temple (Ozar)",
          description: "Located near the banks of the Kukadi River, this temple is known for its mesmerizing architectural design and is considered a symbol of the power of Lord Ganesha. The temple's tranquil surroundings and the idol of Vighneshwar make it a popular spot for devotees seeking blessings and peace."
        },
        {
          title: "Girijatmaja Temple (Lenyadri)",
          description: "Situated in Lenyadri, this temple is unique because it is located inside a mountain cave. The temple offers a peaceful ambiance for reflection and worship, with stunning views of the surrounding hills. It is one of the most serene temples in the Ashtavinayak circuit."
        },
        {
          title: "Chintamani Temple (Theur)",
          description: "Situated in Theur, this temple is known for its serene environment and the Chintamani idol, which is believed to relieve devotees from worries. The peaceful surroundings and the temple's spiritual significance make it an ideal place for contemplation and prayers."
        },
        {
          title: "Mahad Temple (Mahad)",
          description: "This temple is located in Mahad and is known for its historic significance. It has an ancient idol of Lord Ganesha, which is highly revered. The temple’s ancient structure and the divine energy surrounding it make it a place of great devotion for followers of Lord Ganesha."
        }
      ],


  services: [
    {
      "name": "Cab for Ashtavinayak Darshan",
      description: "Embark on a spiritual journey to the Ashtavinayak temples with AB Ghule Cabs. We provide reliable and comfortable cabs for your Ashtavinayak Darshan trip from Pune. Whether you're traveling alone or with a group, our well-maintained vehicles ensure a safe and pleasant experience."
    },
    {
      "name": "Ashtavinayak Darshan Package from Pune",
      description: "AB Ghule Cabs offers a special Ashtavinayak Darshan package from Pune, designed to cover all the important temples in the circuit. Our package includes transport, driver charges, and flexible itineraries. Enjoy a hassle-free pilgrimage with our tailored services."
    },
    {
      "name": "Ashtavinayak Darshan from Pune in 2 Days",
      description: "Our 2-day Ashtavinayak Darshan package is perfect for those who wish to complete the darshan of all eight temples. The package includes comfortable transportation, accommodation, and experienced drivers to guide you through the spiritual journey, ensuring you have a smooth trip."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Service",
      description: "Looking for a taxi service from Pune to Ashtavinayak? AB Ghule Cabs offers reliable and affordable taxi services for your Ashtavinayak Darshan. With our professional drivers and comfortable vehicles, you can focus on your spiritual experience while we take care of the transportation."
    },
    {
      "name": "Pune to Ashtavinayak Tour Package",
      description: "Book your Ashtavinayak tour package from Pune with AB Ghule Cabs. Our package includes transportation, driver services, and a well-planned itinerary, allowing you to visit all eight Ashtavinayak temples comfortably. We ensure a hassle-free experience from start to finish."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Package",
      description: "AB Ghule Cabs offers a customized Ashtavinayak Darshan package from Pune. Whether you want to complete the darshan in a day or over two days, we can tailor the trip to suit your needs. Enjoy an unforgettable experience with our affordable and reliable services."
    },
    {
      "name": "Cheapest Ashtavinayak Tour from Pune",
      description: "If you're looking for a budget-friendly Ashtavinayak tour from Pune, AB Ghule Cabs has you covered. We offer the cheapest Ashtavinayak packages, ensuring that your spiritual journey is affordable without compromising on comfort and quality."
    },
    {
      "name": "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune",
      description: "Traveling in a group? AB Ghule Cabs provides affordable tempo traveller rentals for your Ashtavinayak tour from Pune. Our tempo travellers are spacious and comfortable, allowing your entire group to travel together and enjoy the journey to the Ashtavinayak temples."
    },
    {
      "name": "Pune to Ashtavinayak Cab",
      description: "Book your Pune to Ashtavinayak cab with AB Ghule Cabs for a comfortable and hassle-free trip. Our fleet of vehicles includes sedans, SUVs, and luxury cars, ensuring that you can select the perfect ride for your pilgrimage."
    },
    {
      "name": "Ashtavinayak Yatra Tour Cabs",
      description: "AB Ghule Cabs offers dedicated Ashtavinayak Yatra tour cabs. We provide expert drivers familiar with the Ashtavinayak route, ensuring that you have a safe and comfortable journey while visiting all the sacred temples. Our cabs are available for one-day and two-day trips."
    },
    {
      "name": "Pune to Ashtavinayak Tempo Traveller on Rent",
      description: "For a group journey to Ashtavinayak, AB Ghule Cabs offers tempo travellers for rent. Our spacious tempo travellers can accommodate 12 to 15 passengers, making it an ideal option for family or group trips. The journey is comfortable, and the pricing is affordable."
    },
    {
      "name": "Pune to Ashtavinayak Mini Bus on Rent",
      description: "For larger groups, we offer mini buses for rent from Pune to Ashtavinayak. Our mini buses are well-maintained, air-conditioned, and perfect for group tours. Travel comfortably with your friends or family to all eight Ashtavinayak temples."
    },
    {
      "name": "Pune to Ashtavinayak 17 Seater Bus on Rent",
      description: "AB Ghule Cabs offers a 17-seater bus rental for your Ashtavinayak tour from Pune. Ideal for larger groups, our buses are equipped with all necessary amenities to ensure a comfortable and enjoyable trip. Choose our bus service for a seamless travel experience."
    },
    {
      "name": "Pune to Ashtavinayak Ertiga on Rent",
      description: "For smaller groups or families, AB Ghule Cabs offers the Ertiga on rent for your Ashtavinayak trip. The Ertiga provides a comfortable, spacious, and budget-friendly option for a smooth journey to the Ashtavinayak temples."
    },
    {
      "name": "Ashtavinayak Tour from Pune by Car Package",
      description: "Enjoy a comfortable and hassle-free Ashtavinayak Darshan with our Ashtavinayak tour from Pune by car package. Our package includes all transportation services, allowing you to visit all eight temples in a relaxed and enjoyable manner."
    },
    {
      "name": "Pune to Ashtavinayak Innova Crysta on Rent",
      description: "For a premium travel experience, book the Innova Crysta with AB Ghule Cabs for your Ashtavinayak trip from Pune. The spacious, well-maintained Innova Crysta ensures a luxurious ride to all the Ashtavinayak temples, perfect for families and larger groups."
    },
    {
      "name": "Pune to Ashtavinayak Taxi Fare",
      description: "The taxi fare for your Pune to Ashtavinayak journey depends on the type of vehicle and the duration of your trip. AB Ghule Cabs offers competitive and transparent pricing, ensuring you get the best value for your Ashtavinayak Darshan."
    },
    {
      "name": "Ashtavinayak Darshan Cab Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Ashtavinayak Darshan Cab. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Cab for Ashtavinayak Darshan", "-Ashtavinayak Darshan Package from Pune"],
    ["Ashtavinayak Darshan from Pune in 2 days", "-Pune to Ashtavinayak Taxi Service"],
    ["Pune to Ashtavinayak Tour Package", "-Pune to Ashtavinayak Darshan Package"],
    ["Cheapest Ashtavinayak Tour from Pune", "-Cheapest Tempo Traveller for Ashtavinayak Tour from Pune"],
    ["Pune to Ashtavinayak Cab", "-Ashtavinayak Yatra Tour Cab"],
    ["Pune to Ashtavinayak Tempo Traveller on Rent", "-Pune to Ashtavinayak Mini Bus on Rent"],
    ["Pune to Ashtavinayak 17 Seater Bus on Rent", "-Pune to Ashtavinayak Ertiga on Rent"],
    ["Ashtavinayak Tour from Pune by Car Package", "-Pune to Ashtavinayak Innova Crysta on Rent"],
    ["Pune to Ashtavinayak Taxi Fare", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfortable and Reliable Rides",
      WhyChoosedescription: "Our Ashtavinayak Darshan Cab service ensures you travel in comfort with well-maintained vehicles. Whether you’re traveling alone or with family, we offer a variety of vehicles to suit your needs. Enjoy a smooth, comfortable, and safe ride to all the Ashtavinayak temples."
    },
    {
      WhyChooseheading: "Experienced Drivers",
      WhyChoosedescription: "Our professional drivers are well-versed in the routes to all the Ashtavinayak temples. With their extensive knowledge of the area, they ensure a safe and timely journey, guiding you through every step of the Darshan experience."
    },
    {
      WhyChooseheading: "Affordable Packages",
      WhyChoosedescription: "We offer competitive pricing with transparent fare structures for the Ashtavinayak Darshan. You can choose from a variety of packages that best suit your time and budget, with no hidden charges."
    },
    {
      WhyChooseheading: "Flexible and Customizable Itineraries",
      WhyChoosedescription: "We understand that every traveler’s needs are different. That’s why we offer flexible packages that allow you to customize your itinerary based on the number of temples you wish to visit and the time you have available."
    },
    {
      WhyChooseheading: "Comfortable Fleet of Vehicles",
      WhyChoosedescription: "Our fleet includes a range of vehicles from sedans to SUVs, ensuring comfort throughout your journey. Whether you’re planning a solo trip, a family outing, or a group tour, we have the perfect vehicle for your needs."
    },
    {
      WhyChooseheading: "Punctuality and Timely Service",
      WhyChoosedescription: "Timeliness is crucial for a religious trip like Ashtavinayak Darshan. We prioritize punctuality and ensure you arrive at each temple on time for a seamless and fulfilling darshan experience."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available 24/7 to cater to your travel needs. Whether you wish to begin your darshan early in the morning or in the evening, we are here to serve you at your convenience."
    },
    {
      WhyChooseheading: "Safe and Secure Travel",
      WhyChoosedescription: "Your safety is our top priority. All our drivers are thoroughly background-checked and trained to ensure a safe journey. Our vehicles are regularly inspected and maintained to provide a secure and comfortable ride."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an Ashtavinayak Darshan Cab with AB Ghule Cabs?',
      answer: 'You can easily book an Ashtavinayak Darshan Cab through our website, mobile app, or by calling our customer service. Provide your travel details, and we will confirm your booking promptly.',
    },
    {
      id: 'FAQ2',
      question: 'How many temples are included in the Ashtavinayak Darshan tour?',
      answer: 'The Ashtavinayak Darshan includes visiting eight sacred Ganesh temples located in and around Pune. We offer packages that cover all eight temples or can customize the tour based on your preferences.',
    },
    {
      id: 'FAQ3',
      question: 'What is the cost of the Ashtavinayak Darshan Cab?',
      answer: 'The cost varies depending on the type of vehicle and the number of temples you wish to visit. We offer affordable packages with no hidden charges. For a detailed quote, please contact our customer service.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for stops or deviations?',
      answer: 'Any additional stops or deviations from the scheduled itinerary may incur extra charges. We will inform you of any additional costs beforehand to ensure transparency.',
    },
    {
      id: 'FAQ5',
      question: 'Is the Ashtavinayak Darshan tour available for a single day?',
      answer: 'Yes, our Ashtavinayak Darshan packages are available for single-day trips. We can customize the itinerary to fit your schedule, ensuring that you visit all the temples in a single day or over multiple days.',
    },
    {
      id: 'FAQ6',
      question: 'What type of vehicles do you offer for the Ashtavinayak Darshan?',
      answer: 'We offer a wide range of vehicles including sedans, SUVs, and luxury cars to ensure your comfort during the journey. Depending on your group size and preferences, we will recommend the best vehicle.',
    },
    {
      id: 'FAQ7',
      question: 'Can I book a return trip from Ashtavinayak Darshan?',
      answer: 'Yes, you can book a return trip to your destination after completing your Ashtavinayak Darshan. We offer both one-way and round-trip services to and from the temples.',
    },
    {
      id: 'FAQ8',
      question: 'How long does the Ashtavinayak Darshan tour take?',
      answer: 'The duration of the tour depends on the number of temples you plan to visit. Typically, the entire Ashtavinayak Darshan tour takes about 12-14 hours to complete.',
    },
    {
      id: 'FAQ9',
      question: 'Are your drivers familiar with the route to all the temples?',
      answer: 'Yes, all our drivers are experienced and knowledgeable about the routes to all the Ashtavinayak temples, ensuring a smooth and hassle-free journey.',
    },
    {
      id: 'FAQ10',
      question: 'How do I make payment for the cab service?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app or website, providing you with flexibility and convenience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Sameer Joshi',
      feedback: 'I had an incredible experience with AB Ghule Cabs on my Ashtavinayak Darshan tour. The driver was punctual, professional, and made sure I reached each temple on time. The car was comfortable, and the journey was smooth. I would highly recommend them for anyone looking to visit Ashtavinayak temples!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Aishwarya Reddy',
      feedback: 'Our Ashtavinayak Darshan trip was made easy and enjoyable by AB Ghule Cabs. The driver was friendly, knowledgeable, and ensured our safety throughout the journey. The vehicle was clean and well-maintained. A very smooth experience overall!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Ashtavinayak Darshan Cab | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book your Ashtavinayak Darshan Cab with AB Ghule Cabs. Offering affordable, reliable taxi services and tour packages from Pune to Ashtavinayak temples, including 2-day tours, taxi services, and bus rentals. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="cab for ashtavinayak darshan, Ashtavinayak Darshan Package from Pune, ashtavinayak darshan from pune in 2 days, pune to ashtavinayak taxi service, Pune to Ashtavinayak Tour Package, pune to ashtavinayak darshan package, Cheapest Ashtavinayak tour from Pune, Cheapest Tempo Traveller for Ashtavinayak Tour from Pune, pune to ashtavinayak cab, Ashtavinayak Yatra Tour Cabs, pune to ashtavinayak tempo traveller on rent, pune to ashtavinayak mini bus on rent, pune to ashtavinayak 17 seater Bus on Rent, pune to ashtavinayak ertiga On Rent, ashtavinayak tour from pune by car package, pune to ashtavinayak innova Crysta on Rent, Pune to ashtvinayak taxi fare" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Ashtavinayak Darshan Cab | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book your Ashtavinayak Darshan Cab with AB Ghule Cabs. Offering affordable, reliable taxi services and tour packages from Pune to Ashtavinayak temples, including 2-day tours, taxi services, and bus rentals. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/ashtavinayak-darshan-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/ashtavinayak-darshan-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Ashtavinayak Darshan Cab",
        description: "Book your Ashtavinayak Darshan Cab with AB Ghule Cabs. Offering affordable, reliable taxi services and tour packages from Pune to Ashtavinayak temples, including 2-day tours, taxi services, and bus rentals. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/ashtavinayak-darshan-cab",
        "logo": "https://abghulecabs.com/images/ashtavinayak-darshan-cab.jpg",
        "image": "https://abghulecabs.com/images/ashtavinayak-darshan-cab.jpg",
        "priceRange": "₹2500 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/ashtavinayak-darshan-cab",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ananya R"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "The Ashtavinayak Darshan package from Pune was a great experience. The driver was professional and the car was clean. Highly recommend AB Ghule Cabs for temple tours!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh Patil"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "Booked a 2-day Ashtavinayak tour package. The trip was smooth, and we had a comfortable ride throughout. Excellent service from AB Ghule Cabs!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Ashtavinayak Darshan",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5210",
            "longitude": "73.8558"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/ashtavinayak-darshan-cab"
        },
        "keywords": "cab for ashtavinayak darshan, Ashtavinayak Darshan Package from Pune, ashtavinayak darshan from pune in 2 days, pune to ashtavinayak taxi service, Pune to Ashtavinayak Tour Package, pune to ashtavinayak darshan package, Cheapest Ashtavinayak tour from Pune, Cheapest Tempo Traveller for Ashtavinayak Tour from Pune, pune to ashtavinayak cab, Ashtavinayak Yatra Tour Cabs, pune to ashtavinayak tempo traveller on rent, pune to ashtavinayak mini bus on rent, pune to ashtavinayak 17 seater Bus on Rent, pune to ashtavinayak ertiga On Rent, ashtavinayak tour from pune by car package, pune to ashtavinayak innova Crysta on Rent, Pune to ashtvinayak taxi fare"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/27.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Ashtavinayakdarshan;